import React from "react";

const Bash_Alias = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Alias</h2>
      <p>Create shortcuts for commands.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>alias name='command'</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>alias ll='ls -la'
alias gs='git status'</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Put aliases in ~/.bashrc to persist.</p>
    </div>
  );
};

export default Bash_Alias;
